import { createRoot } from "react-dom/client";
import { ConfigProvider, theme } from "antd";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import App from "./App.tsx";


import { ThemeProvider, useThemeContext } from "./context/ThemeContext";

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      retry: true,
      refetchOnWindowFocus: false,
    },
  },
});

const lightTokens: any = {
  colorPrimary: "#0a57c2",
  colorSuccess: "#10b981",
  colorBgBase: "#f5f7f8",
  colorBgLayout: "#f6f7f8",
  colorBgContainer: "#ffffff",
  colorText: "#111418",
  colorTextSecondary: "#60728a",
  borderRadius: 8,
  fontFamily: "Manrope, sans-serif",
  customBgBlur: "rgba(255, 255, 255, 0.85)",
  customBgGradientFooter: "linear-gradient(to top, white, rgba(255,255,255,0.95))",
};

const darkTokens: any = {
  colorPrimary: "#2b8cee", // Slightly brighter blue for dark mode
  colorSuccess: "#10b981",
  colorBgBase: "#000000",
  colorBgLayout: "#141414",
  colorBgContainer: "#191919",
  colorText: "#e5e7eb",
  colorTextSecondary: "#9ca3af",
  borderRadius: 8,
  fontFamily: "Manrope, sans-serif",
  customBgBlur: "rgba(20, 20, 20, 0.85)",
  customBgGradientFooter: "linear-gradient(to top, #141414, rgba(20,20,20,0.95))",
};

const AppContainer = () => {
  const { isDarkMode } = useThemeContext();
  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: isDarkMode ? darkTokens : lightTokens,
      }}
    >
      <App />
    </ConfigProvider>
  );
};

createRoot(document.getElementById("root")!).render(
  <>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AppContainer />
      </ThemeProvider>
    </QueryClientProvider>
  </>,
);
